import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface AuthMethod {
  authType: string;
  isActive: boolean;
}

export interface UserAuthMethodsResponse {
  userAuthMethodList: AuthMethod[];
  receiptauthorizationmethod: string | null;
  errorCode: string | null;
  errorMessage: string | null;
  isActive: boolean | null;
  inactiveReason: string | null;
}

export interface GetPinCodeRequest {
  method: string;
  organizationInn: string;
  personIdnp: string;
}

export interface GetPinCodeResponse {
  success?: boolean;
  ok?: boolean;
  status?: number;
  msg?: string;
  errorCode?: string;
  errorMessage?: string;
}

/** Конверт ответа платформы: данные лежат в `res`. */
export interface ApiEnvelope<T> {
  success: boolean;
  msg: string | null;
  res: T;
  time?: string;
  ver?: string;
}

export interface AccountAuthRequest {
  byPin: string;
  organizationInn: string;
  personIdnp: string;
}

export interface AccountAuthResult {
  token: string;
  personIdnp: string;
  organizationInn: string;
  commonName: string;
  organizationName: string;
  countryName: string;
}

export interface AccountAuthResponse {
  success: boolean;
  msg: string;
  res: AccountAuthResult | null;
  time: string;
  ver: string;
}

@Injectable({
  providedIn: 'root'
})
export class OepService {
  constructor(private http: HttpClient) {}



  getUserAuthMethods(organizationInn: string, personIdnp: string): Observable<ApiEnvelope<UserAuthMethodsResponse>> {
    return this.http.post<ApiEnvelope<UserAuthMethodsResponse>>(
      environment.api.oep.userAuthMethods,
      { organizationInn, personIdnp }
    );
  }

 
  getPinCode(request: GetPinCodeRequest): Observable<ApiEnvelope<GetPinCodeResponse>> {
    return this.http.post<ApiEnvelope<GetPinCodeResponse>>(
      environment.api.oep.getPinCode,
      request
    );
  }


  accountAuth(request: AccountAuthRequest): Observable<AccountAuthResponse> {
    return this.http.post<AccountAuthResponse>(
      environment.api.oep.accountAuth,
      request
    );
  }
}
